import type { Order } from '@trmediaab/zebra-types/trhub';
import { useCallback } from 'react';

import type { CheckoutState } from '../../state';
import {
  setCheckoutStep,
  setOrder,
  setQuantity,
  useImmutableState,
} from '../../state';
import type { OrderChangeCallback } from '../../state/useOrderSubscription';
import useOrderSubscription from '../../state/useOrderSubscription';
import request from '../../utils/request';
import Layout from '../Layout';
import TextButton from '../TextButton';
import type { ProductLineitemsCardProps } from './ProductLineitemsCard';
import ProductLineitemsCard from './ProductLineitemsCard';
import ShippingSummaryCard from './ShippingSummaryCard';

interface CartProps {
  order: NonNullable<CheckoutState['order']>;
  editable: boolean;
  showChangeProduct: boolean;
}

const Cart = ({ order, editable, showChangeProduct }: CartProps) => {
  const { appMode, isCampaign } = useImmutableState();

  const updateOrder = useCallback(async (order: Order) => {
    try {
      const data = await request<Order>('order', {
        method: 'PUT',
        body: order,
      });

      setOrder(data);
    } catch (error) {
      console.error(error);
    }
  }, []);

  const changeQuantity = useCallback<
    ProductLineitemsCardProps['onChangeQuantity']
  >(async (event, idx) => {
    const { value } = event.target;
    const quantity = Number.parseInt(value);

    setQuantity(quantity, idx);
  }, []);

  const orderSubscription = useCallback<OrderChangeCallback>(
    (changes, order) => {
      const needsUpdate = changes.some(
        ([op, path]) =>
          op === 'set' &&
          path.length > 1 &&
          (path.includes('quantity') || path.includes('country')),
      );

      if (needsUpdate) {
        updateOrder(order);
      }
    },
    [updateOrder],
  );

  useOrderSubscription(orderSubscription);

  return (
    <>
      <ProductLineitemsCard
        order={order}
        allowQuantityChange={
          editable && !isCampaign && appMode !== 'redeemGift'
        }
        onChangeQuantity={changeQuantity}
      />

      <ShippingSummaryCard order={order} isFinalShipping={!editable} />

      {/* 
        TODO - speltips/klippkort: Ändra ditt val -> länk tillbaka till siten 
        mt: hack to undo some space created by grid gap
      */}
      {showChangeProduct && (
        <Layout.area area="changeProduct" mt={['-14px', null, '-16px']}>
          <TextButton
            onClick={() => setCheckoutStep('product')}
            label="Ändra betalperiod"
          />
        </Layout.area>
      )}
    </>
  );
};

export default Cart;
